

// export const ticketBase = 'http://218.77.187.131:8098';//票务
// // export const ticketBase = 'http://172.16.9.51:8081/';//票务
// export const shoppingBase = 'http://218.77.187.131:8098';// 海博堂
// export const culturalRelicsBase = 'http://218.77.187.131:8098';//文物
// export const newsBase = 'http://218.77.187.131:8098';// 包含志愿者模块 新闻 留言

export const ticketBase = window._api_ticketBase;//票务
export const shoppingBase = window._api_shoppingBase;// 海博堂
export const culturalRelicsBase = window._api_culturalRelicsBase;//文物
export const newsBase = window._api_newsBase;// 包含志愿者模块 新闻 留言
export const AuthorizationBASE = window._api_AuthorizationBASE;// 包含微信接口地址 ,获取openId及用户信息 ,获取accessToken
export const PersonalBaseURL = 'http://ticket.hnswb.net'; // 个人中心各模块接口地址
export const VolunteerBaseURL = 'http://voladm.hnswb.net'; // 志愿者相关接口地址
